import { _ as _construct } from "@swc/helpers/_/_construct";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { FlingGesture } from "./flingGesture";
import { ForceTouchGesture } from "./forceTouchGesture";
import { ComposedGesture, ExclusiveGesture, SimultaneousGesture } from "./gestureComposition";
import { LongPressGesture } from "./longPressGesture";
import { PanGesture } from "./panGesture";
import { PinchGesture } from "./pinchGesture";
import { RotationGesture } from "./rotationGesture";
import { TapGesture } from "./tapGesture";
import { NativeGesture } from "./nativeGesture";
import { ManualGesture } from "./manualGesture";
import { HoverGesture } from "./hoverGesture";
export var GestureObjects = {
    Tap: function() {
        return new TapGesture();
    },
    Pan: function() {
        return new PanGesture();
    },
    Pinch: function() {
        return new PinchGesture();
    },
    Rotation: function() {
        return new RotationGesture();
    },
    Fling: function() {
        return new FlingGesture();
    },
    LongPress: function() {
        return new LongPressGesture();
    },
    ForceTouch: function() {
        return new ForceTouchGesture();
    },
    Native: function() {
        return new NativeGesture();
    },
    Manual: function() {
        return new ManualGesture();
    },
    Hover: function() {
        return new HoverGesture();
    },
    /**
   * Builds a composed gesture consisting of gestures provided as parameters.
   * The first one that becomes active cancels the rest of gestures.
   */ Race: function() {
        for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
            gestures[_key] = arguments[_key];
        }
        return _construct(ComposedGesture, _to_consumable_array(gestures));
    },
    /**
   * Builds a composed gesture that allows all base gestures to run simultaneously.
   */ Simultaneous: function Simultaneous() {
        for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
            gestures[_key] = arguments[_key];
        }
        return _construct(SimultaneousGesture, _to_consumable_array(gestures));
    },
    /**
   * Builds a composed gesture where only one of the provided gestures can become active.
   * Priority is decided through the order of gestures: the first one has higher priority
   * than the second one, second one has higher priority than the third one, and so on.
   * For example, to make a gesture that recognizes both single and double tap you need
   * to call Exclusive(doubleTap, singleTap).
   */ Exclusive: function Exclusive() {
        for(var _len = arguments.length, gestures = new Array(_len), _key = 0; _key < _len; _key++){
            gestures[_key] = arguments[_key];
        }
        return _construct(ExclusiveGesture, _to_consumable_array(gestures));
    }
};
